import * as React from 'react';
import { white } from '../colors';

/* eslint-disable max-len */
const WarningSvg = (props: { [otherOptions: string]: unknown }) => (
  <svg
    width="16px"
    height="16px"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    color={white}
    {...props}
  >
    <path
      d="M836.759 298.784l-9.885-19.607A2.106 2.106 0 00825 278c-.787 0-1.509.453-1.874 1.177l-9.886 19.607a2.27 2.27 0 00.065 2.157 2.1 2.1 0 001.81 1.059h19.769a2.1 2.1 0 001.81-1.06 2.27 2.27 0 00.064-2.156zm-12.817-12.717c0-.606.474-1.098 1.058-1.098.584 0 1.058.492 1.058 1.098v6.591c0 .607-.474 1.098-1.058 1.098-.584 0-1.058-.491-1.058-1.098v-6.59zm1.11 12.643h-.029c-.866-.003-1.576-.715-1.61-1.614a1.657 1.657 0 01.427-1.174 1.535 1.535 0 011.105-.507h.03c.866.001 1.577.712 1.611 1.611.017.436-.137.86-.425 1.178-.289.317-.688.5-1.108.506z"
      transform="translate(-813 -278)"
      stroke="none"
      strokeWidth={1}
      fillRule="evenodd"
    />
  </svg>
);

export default WarningSvg;
